export const LoginAdmin_REQUEST = "LoginAdmin_REQUEST";
export const LoginAdmin_SUCCESS = "LoginAdmin_SUCCESS";
export const LoginAdmin_FAIL = "LoginAdmin_FAIL";

export const LogoutAdmin = "LogoutAdmin";
